import { BasicNode, BasicNodeProps } from "./BasicNode";
const QueuedNode = (props: BasicNodeProps) => (
  <BasicNode {...props} className="border-amber-500 bg-amber-100" />
);

export default QueuedNode;
